export function multipartRanges(byteSize: number, partSize: number): Array<{ partNumber: number; start: number; end: number }> {
  if (!Number.isSafeInteger(byteSize) || byteSize <= 0 || !Number.isSafeInteger(partSize) || partSize <= 0) throw new Error("Multipart sizes must be positive safe integers.");
  return Array.from({ length: Math.ceil(byteSize / partSize) }, (_, index) => ({
    partNumber: index + 1,
    start: index * partSize,
    end: Math.min(byteSize, (index + 1) * partSize),
  }));
}
